import React from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import BackToTop from "../../components/back-to-top"
import { Container, Row, Col } from "reactstrap"
import { LazyLoadImage } from "react-lazy-load-image-component"

const NateMiller = () => {
  return (
    <Layout>
      <Seo title="Doctor Nate Miller, DVM" />
      <div className="hero-adjustment pb-0">
        <div className="container">
          <div className="hero-content-wrapper">
            <div className="row no-gutters">
              <div className="col-12 col-md-7">
                <div className="hero-dog-bg">
                  <div className="dog-bg"></div>
                </div>
              </div>
              <div className="col-12 col-md-5">
                <div className="hero-video">
                  <div>
                    <div>
                      <div className="video-modal-btn no-video">
                        <LazyLoadImage
                          effect="blur"
                          src="/assets/img/tplo-video.jpg"
                          alt="video"
                          className="video-img img-fluid v-h"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-only-heading inner-page-title text-right arthroscopy-hero no-videoHero">
              <h1>
                Meet <br />
                Dr. Nate
                <br />
                Miller
              </h1>
            </div>
          </div>
        </div>
      </div>
      <Container className="acl-container mb-5 mt-5 mt-md-0">
        <div className="doctor-body">
          <Row className="border-none">
            <Col md={4} className="img-resp">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/dr-nate-miller.jpg"
                alt="Doctor"
                className="img-fluid mb-4"
              />
            </Col>
            <Col md={8}>
              <p>
                Dr. Miller grew up in Evergreen, Colorado. He received his
                undergraduate degree from Harvard University and returned to
                Colorado, graduating from Colorado State University Veterinary
                School. He was intern of the year at North Carolina State
                University and completed his surgical residency at the
                University of Georgia in 2002. He became board certified by the
                American College of Veterinary Surgeons in 2004.
              </p>
              <p>
                Dr. Miller has practiced in Denver, CO and Santa Cruz, CA. He
                returned to Colorado in 2012 and joined the team at Colorado
                Canine Orthopedics and couldn’t be happier.
              </p>
              <p>
                Dr. Miller has extensive experience in arthroscopy and has been
                an instructor in courses nationally. Other professional
                interests include joint replacement and correction of limb
                deformities
              </p>
              <p>
                Dr. Miller’s family consists of his wife Christine, his two
                daughters Jessie and Charlotte, and Fred the corgi. He enjoys
                cycling, fishing, and spending time with his family.
              </p>
            </Col>
          </Row>
        </div>
      </Container>
      <BackToTop />
    </Layout>
  )
}

export default NateMiller
